import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Divider, Container, Typography, Stack } from '@mui/material';
// routes
// import { PATH_PAGE } from '../../routes/paths';
// components
import Logo from '../../components/Logo';
// import SocialsButton from '../../components/SocialsButton';
import NewImage from '../../assets/NewImage';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Quick Links',
    children: [
      { name: 'Home', href: '#' },
      { name: 'How it work', href: '#' },
      { name: 'Sign Up', href: '#' },
      { name: 'Our Team', href: '#' },
      { name: 'Faq', href: '#' },
      { name: 'Privacy Policy', href: '#' },
    ],
  },

  {
    headline: 'Get In Touch',
    children: [
      { name: '+1 818-934-8030', href: '#' },
      { name: 'Support@mentorbooth.com', href: '#' },
    ],
  },
  {
    headline: 'Coming Soon to app Store',
    children: [
      { name: 'support@minimals.cc', href: '#' },
      { name: 'Los Angeles, 359  Hidden Valley Road', href: '#' },
    ],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#000',
  zIndex: '999',
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <div className='main-foter-section'>
        <Container sx={{ pt: 5 }}>
          <Grid className='grid-footer-sec'
            container
            justifyContent={{ xs: 'center', md: 'space-between' }}
            sx={{ textAlign: { xs: 'center', md: 'left' } }}
          >
            <Grid className='footer-content-grid' item xs={4} md={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="footer-col" style={{ display: 'inline-block' }}>
                <Grid className='footer-grid' item xs={8} sx={{ mb: 1 }}>
                  <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
                </Grid>
                <Typography variant="body2" sx={{md: 5, color: '#fff'}}>
                  6928 Owensmouth Ave #105 Canoga Park, CA 91303
                </Typography>
                <Typography variant="body2" sx={{ pr: { md: 5, color: '#fff' } }}>
                  <h2 style={{ marginTop:'15px' }}>Get In Touch</h2>
                </Typography>
                <ul style={{ color: '#fff', listStyleType: 'none' }}>
                  <li> +1 818-934-8030</li>
                  <li>Support@mentorbooth.com </li>
                </ul>
              </div>
            </Grid>
            <Grid className='grid-quick-links' item xs={8} md={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="footer-col" style={{ display: 'inline-block' }}>
                <Typography variant="body2" sx={{ pr: { color: '#fff' } }}>
                 <h2>Quick Links</h2> 
                  {/* <ul style={{listStyleType:'none',}}> <li>Home </li>
                  <li><a href='#' style={{color:'#fff',textDecoration:'none'}}>  How it work</a> </li>
                  <li><a href='#' style={{color:'#fff',textDecoration:'none'}}>Sign up </a></li>
                  <li><a href='#' style={{color:'#fff',textDecoration:'none'}}>Our Team </a></li>
                  <li><a href='#' style={{color:'#fff',textDecoration:'none'}}>FAQ </a></li>
                  <li><a href='#' style={{color:'#fff',textDecoration:'none'}}>Privacy Policy</a> </li>
                  <li><a href='#' style={{color:'#fff',textDecoration:'none'}}>Terms And Condition </a></li>

                </ul> */}
                <div className='footer-list footer-new-links'>
                  <ul style={{ listStyleType: 'none' }}>
                    <li>
                      <a href="https://mentorbooth.com" style={{ color: '#fff', textDecoration: 'none' }}>
                        Home
                      </a>
                    </li>
                    <li>
                      <a href="https://mentorbooth.com/about/" style={{ color: '#fff', textDecoration: 'none' }}>
                        About
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://mentorbooth.com/app"
                        rel="noopener"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        Sign Up
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mentorbooth.com/faq/"
                        rel="noopener"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                    <a href="https://mentorbooth.com/author" rel="noopener"  style={{ color: '#fff', textDecoration: 'none' }}>Author</a>
                    </li>
                  </ul>
                  <ul style={{ listStyleType: 'none' }}>
                    <li>
                      <a
                        href="https://mentorbooth.com/coach"
                        rel="noopener"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        Coach
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mentorbooth.com/privacy-policy-2/"
                        rel="noopener"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        Privacy policy
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://mentorbooth.com/pricing"
                        rel="noopener"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mentorbooth.com/term-and-condition/"
                        rel="noopener"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        Terms and conditions
                      </a>
                    </li>
                  </ul>
                  </div>
                </Typography>
              </div>
            </Grid>
            {/* <Grid item xs={8} md={3}  style={{display:"flex", justifyContent:'center'}} >
            <div className='footer-col' style={{display:"inline-block"}}>
              <Typography variant="body2" sx={{ pr: { md: 5, color: '#fff' } }}>
                Get In Touch
              </Typography>
              <ul style={{color:'#fff',listStyleType:'none'}}>
                <li> +1 818-934-8030</li>
                <li>Support@mentorbooth </li>
              </ul>

</div>
            </Grid> */}

            <Grid item xs={12} md={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="footer-col" style={{ display: 'inline-block' }}>
                {/* <Typography variant="body2" sx={{ pr: { md: 5, color: '#fff' } }}>
                  Get In Touch
                </Typography> */}
                <ul style={{ listStyleType: 'none', mb: 1 }}>
                  <li style={{ marginBottom: '20px'}}>
                    <img src={NewImage.appstore} alt="" />{' '}
                  </li>
                  <li>
                    {' '}
                    <img src={NewImage.googleplay} alt="" />
                  </li>
                  <li style={{ padding: '10px 0px 20px 0px' }}>
                    {' '}
                    <h2 style={{color: '#fff', padding: '10px' }}>Follow Us On</h2>{' '}
                    {/* <div style={{ display: 'flex' }}>
                      {' '}
                      <img src={NewImage.fbicon} alt="" /> <img src={NewImage.instagram} alt="" />{' '}
                     
                      <img src={NewImage.twitter} alt="" />
                    </div> */}
                    <div style={{display: 'flex'}} className='social-icon'>
                <a  href="https://www.facebook.com/mentorbooth" rel="noopener">
                <img src='http://www.binc.co.in/wp-content/uploads/2022/08/facebook.png' alt="" /> </a>
                <a  href="https://twitter.com/MentorBooth_app" rel="noopener">
                <img src='http://www.binc.co.in/wp-content/uploads/2022/08/twitter.png' alt="" /></a>
								<a  href="https://www.instagram.com/mentorbooth.app/" rel="noopener">
                <img src='http://www.binc.co.in/wp-content/uploads/2022/08/instagram.png' alt="" /></a>
                <a href="https://www.linkedin.com/company/mentorbooth/" rel="noopener">
                <img src='https://www.binc.co.in/wp-content/uploads/2022/08/linked-in.png' alt="" /></a>
	 </div>
                  </li>
                </ul>
              </div>
            </Grid>
          </Grid>
         
        </Container>
        <Grid container>
            <Grid item xs={12}>
              <Stack>
                <Typography
                  component="p"
                  variant="body2"
                  sx={{
                  

                    fontSize: 13,
                    textAlign: { xs: 'center', md: 'center' },
                  }}
                >
                  <div  style={{backgroundColor: '#1790bc', padding: '15px'}}>
                     <p style={{color:'#fff'}}>© 2023. All rights reserved</p>
                  </div>
               
                </Typography>
              </Stack>
            </Grid>
          </Grid>
      </div>
    </RootStyle>
  );
}
